import React, { useRef, useEffect } from 'react'
import styles from './ValueSection.module.scss'
import { WithI18nProps } from '@/types/i18n'
import { createMerchantI18n, getLocaleStyleClass } from '@/utils/i18n'
import { withTranslator } from '@common/hoc/translatorHoc'
import arrowRight from '@assets/img/arrowRight.png'


const ValueSection: React.FC<WithI18nProps> = ({ i18n }) => {
  const t = React.useMemo(() => createMerchantI18n(i18n), [i18n])
  // 视频链接占位，后续替换为实际CDN地址
  const videoSrcList = [
    'https://p0.meituan.net/travelcube/4749d18aca4de64231005a2d3727e62a256028.png@608w_80q',
    'https://p1.meituan.net/travelcube/d3debd60057b56b519b3fbda2574a74d298262.png@684w_80q',
    'https://p0.meituan.net/travelcube/9e4f88df303dfd415e6cf61a8529f7b5224732.png@608w_80q',
  ]

  const videoRefs = [useRef<HTMLVideoElement>(null), useRef<HTMLVideoElement>(null), useRef<HTMLVideoElement>(null)]

  // 组件挂载后自动播放所有视频
  useEffect(() => {
    videoRefs.forEach(videoRef => {
      const video = videoRef.current
      if (video) {
        video.play().catch(() => {})
      }
    })
  }, [])

  const  getCurrentLanguage = () => {
    if (!i18n) return 'zh-CN';
    return i18n.getLocale() || 'zh-CN';
  };

  const getCurrentLanguageClass = (style: string): string => {
    return getLocaleStyleClass(getCurrentLanguage(), style)
  }


  return (
    <section className={styles.section}>
      <div className={styles.contentWrapper}>
        <div className={`${styles.sectionHeader} ${styles[getCurrentLanguageClass('sectionHeader')]}`}>
          {t('marketingToolsTitle1', "多元营销工具组合")},{t('marketingToolsTitle2', " 精准赋能店铺生意增长")}
        </div>
        <div className={styles.valueGrid}>
          {/* 交易合作 */}
          <div 
            className={styles.valueCard}
          >
            <img
              src={videoSrcList[0]}
            />
            <div className={styles.cardContent}>
              <div className={`${styles.cardTitle} ${styles[getCurrentLanguageClass('cardTitle')]}`}>{t('marketingToolsItem1', "团购套餐")}</div>
              <div className={`${styles.cardDesc} ${styles[getCurrentLanguageClass('cardDesc')]}`}>{t('marketingToolsItem1Description', "套餐优惠组合")}</div>
              <div className={`${styles.cardHighlight} ${styles[getCurrentLanguageClass('cardHighlight')]}`}>
                <img src={arrowRight} alt="arrowRight" />
                <span>{t('marketingToolsItem1SpecialDescription', "刺激即时消费")}</span>
              </div>
            </div>
          </div>

          {/* 商户通 */}
          <div 
            className={styles.valueCard}
          >
            <img
              src={videoSrcList[1]}
            />
            <div className={styles.cardContent}>
              <div className={`${styles.cardTitle} ${styles[getCurrentLanguageClass('cardTitle')]}`}>{t('marketingToolsItem2', "商户通")}</div>
              <div className={`${styles.cardDesc} ${styles[getCurrentLanguageClass('cardDesc')]}`}>{t('marketingToolsItem2Description', "专业级门店装修 + 交易转化引擎")}</div>
              <div className={`${styles.cardHighlight} ${styles[getCurrentLanguageClass('cardHighlight')]}`}>
                <img src={arrowRight} alt="arrowRight" />
                <span>{t('marketingToolsItem2SpecialDescription', "打造高吸引力门店页面")}</span>
              </div>
            </div>
          </div>

          {/* 推廣通 */}
          <div 
            className={styles.valueCard}
          >
            <img
              src={videoSrcList[2]}
            />
            <div className={styles.cardContent}>
              <div className={`${styles.cardTitle} ${styles[getCurrentLanguageClass('cardTitle')]}`}>{t('marketingToolsItem3', "推广通")}</div>
              <div className={`${styles.cardDesc} ${styles[getCurrentLanguageClass('cardDesc')]}`}>{t('marketingToolsItem3Description', "关键词竞价 + 信息流曝光")}</div>
              <div className={`${styles.cardHighlight} ${styles[getCurrentLanguageClass('cardHighlight')]}`}>
                <img src={arrowRight} alt="arrowRight" />
                <span>{t('marketingToolsItem3SpecialDescription', "精准触达意向用户")}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default withTranslator(ValueSection)

